import { render, staticRenderFns } from "./Gameplay.vue?vue&type=template&id=1e0fa01e&"
import script from "./Gameplay.vue?vue&type=script&lang=js&"
export * from "./Gameplay.vue?vue&type=script&lang=js&"
import style0 from "./Gameplay.vue?vue&type=style&index=0&id=1e0fa01e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.8.1_vue-template-compiler@2.7.14_webpack@5.86.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports